/* eslint-disable */

import { reactive, watch, ref, onMounted, createApp, nextTick } from "vue";


export function useMenu() {
    let showMenu = ref(false);

    const closeMenu = () => {
        showMenu.value = false
    }
    const openMenu = () => {
        showMenu.value = true
    }

    return { showMenu, closeMenu, openMenu };
}
